module.exports = __webpack_public_path__ + "static/media/banner-image.0da7599c.webp";